export default __webpack_public_path__ + "static/media/08.49be1af6.jpg";